import { type RouteObject, useSearchParams } from "react-router";
import { HomePage } from "./ui/HomePage";

/**
 * Storefront routes, rendered inside the ShopLayout by the app router. The home page ships in
 * the main bundle (first screen); the other pages are lazy-loaded. `handle.shell` places each page in the mobile
 * app shell (tab, home header, canvas background, tab bar).
 */
export const catalogRoutes: RouteObject[] = [
  {
    index: true,
    handle: { shell: { tab: "home", homeHeader: true, footer: true, canvas: true } },
    element: <HomePage />,
  },
  {
    path: "catalog",
    handle: { shell: { tab: "catalog", canvas: true } },
    lazy: async () => ({ Component: (await import("./ui/CatalogPage")).CatalogPage }),
  },
  {
    path: "catalog/:slug",
    handle: { shell: { tab: "catalog", canvas: true } },
    lazy: async () => {
      const { ListingPage } = await import("./ui/ListingPage");
      return { Component: () => <ListingPage mode="category" /> };
    },
  },
  {
    // without a query: the search screen; with ?q=: the results listing
    path: "search",
    handle: { shell: { tab: "catalog", canvas: true } },
    lazy: async () => {
      const [{ ListingPage }, { SearchPage }] = await Promise.all([
        import("./ui/ListingPage"),
        import("./ui/SearchPage"),
      ]);
      return {
        Component: function SearchRoute() {
          const [params] = useSearchParams();
          return params.get("q")?.trim() ? <ListingPage mode="search" /> : <SearchPage />;
        },
      };
    },
  },
  {
    path: "product/:slug",
    // the sticky buy bar replaces the tab bar (D24)
    handle: { shell: { tab: "catalog", tabBar: false, canvas: true } },
    lazy: async () => ({ Component: (await import("./ui/ProductPage")).ProductPage }),
  },
  {
    path: "installment",
    handle: { shell: { tab: "home", canvas: true } },
    lazy: async () => ({ Component: (await import("./ui/InstallmentPage")).InstallmentPage }),
  },
];
